import { SystemConstants } from "@/common/system-constants";
import HttpClient from "@/api/HttpClient";
import { APIHosts, ApiReduxHelpers } from "@/services/reduxHelpers";

class WorkflowApiController extends ApiReduxHelpers {
  ApiHost = APIHosts.Lakehouse;

  public Post = {
    triggerAnalyticsPipe: (data: any) => {
      const url = `${this.getHost(this.ApiHost)}/${SystemConstants.SERVER_LAKEHOUSE.API.WORKFLOW.FROM_EVENT}`;
      try {
         
        console.log("Workflow service POST", url, data);
      } catch (e) {
        /* ignore */
      }

      return HttpClient.post(url, data);
    },
  };
}

export const WorkflowAnalyticService = new WorkflowApiController();
export default WorkflowAnalyticService;
